// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq__title{font-size:18px;font-weight:800}.faq a{color:inherit;text-decoration:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
